import appSettings from 'wanderu-config';

import ApiService from './apiService/apiService';

const GET_DEFAULT_OPTIONS = {
    authViaHeader: true,
    withAuth: true,
};

const POST_DEFAULT_OPTIONS = {
    authViaHeader: true,
    contentType: 'application/json',
    withAuth: true,
};

function removeLeadingSlashes(path: string) {
    return path.replace(/^\/+/, '');
}

function addTrailingSlash(rawPath: string) {
    // eslint-disable-next-line prefer-const
    let [path, query] = rawPath.split('?');

    if (path.charAt(path.length - 1) !== '/') {
        path += '/';
    }

    return `${path}${query
        ? '?' + query
        : ''}`;
}

function formatPath(path: string) {
    return removeLeadingSlashes(addTrailingSlash(path));
}

function buildUrl(path: string) {
    return appSettings.config.orders.urlRoot + formatPath(path);
}

async function get(path: string, init: Record<string, unknown>, options: Record<string, unknown>) {
    return ApiService.get(
        buildUrl(path),
        init,
        {
            ...GET_DEFAULT_OPTIONS,
            ...options,
        },
    );
}

async function post(path: string, init: Record<string, unknown>, options: Record<string, unknown>) {
    return ApiService.post(
        buildUrl(path),
        init,
        {
            ...POST_DEFAULT_OPTIONS,
            ...options,
        },
    );
}

export default {
    get,
    post,
};
